import DateFnsUtils from '@date-io/date-fns'
import { yupResolver } from '@hookform/resolvers'
import { UploadPreview } from '@ifca-root/react-component/src/components/Avatar/UploadPreview'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { VoiceTextField } from '@ifca-root/react-component/src/components/Input/CustomTextField'
import { FileUploadInput } from '@ifca-root/react-component/src/components/Input/FileUploadInput'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import useUploadAttachment from '@ifca-root/react-component/src/utils/hooks/useUploadAttachment'
import {
  Checkbox,
  CircularProgress,
  Grid,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { Autocomplete } from '@material-ui/lab'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import {
  AddFavoriteDialog,
  DeleteFavoriteDialog,
} from 'components/Favorite/FavoriteDialog'
import FavoriteMenu from 'components/Favorite/FavoriteMenu'
import { TooltipAmountFooter } from 'components/Footer/TooltipAmountFooter'
import { ItemDialog } from 'containers/APModule/components/ItemDialog'
import { ItemDetail } from 'containers/ARAPModule/Components/Detail/ItemDetail'
import { IsEinvoiceSelfBilled } from 'containers/ARAPModule/Components/Dialog/EInvoiceComponent/SelfBilledComponent'
import {
  findDuplicates,
  statusInput,
} from 'containers/ARAPModule/Function/DocumentChecker'
import { dueDateChecker } from 'containers/ARAPModule/Helper/DateCalculation'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  DocumentListingDocument,
  GetApFavoriteInvoiceDocument,
  GetApInvoiceDocument,
  GetApInvoicebyStatusDocument,
  RecordStatus,
  useCreateApFavoriteInvoiceMutation,
  useCreateApInvoiceMutation,
  useDeleteApFavoriteInvoiceMutation,
  useDocumentListingLazyQuery,
  useGetApFavoriteInvoiceQuery,
  useGetCompanyNameQuery,
  useGetCostCentreCodeLazyQuery,
  useGetCreditorAccountCompanyAssignmentNameLazyQuery,
  useGetDebtorAccountListingQuery,
  useGetDoItemLazyQuery,
  useGetDocNumTitleQuery,
  useGetDocumentDateValidationQuery,
  useGetEInvoiceCompanyStartLazyQuery,
  useGetExpenseItemLazyQuery,
  useGetGeneralDOsLazyQuery,
  useGetMsicCodeQuery,
  useGetSalesOrderByDebtorLazyQuery,
  useLatestOpenPeriodCheckingDateQuery,
  useUpdateApInvoiceMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { CommonYupValidation } from 'helpers/Form/YupValidation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  formatDashDate,
  formatDate,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router'
import { uuid } from 'uuidv4'
import * as yup from 'yup'
import AuditLog from 'assets/icons/MFRS16/auditlog.svg'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
interface APInvoiceProps {
  //Invoice
  DocDate: string
  TrxDate: string
  CreditorAccountID: string
  DOHeaderID: string
  Description: string
  Remark: string
  InvoiceID: string
  DocAmt: number
  DocNo: string
  RefNo: string
  UIN: string
  isSelfBilled: boolean
  MSICCodeID: string
  DebtorAccountID: string
  SalesOrderID: string
}

interface FavInvoiceProps {
  Name: string
}

export const APInvoiceStateForm = (props: any) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
  const checkedIcon = <CheckBoxIcon fontSize="small" />
  const { CompanyID, InvoiceID }: any = useParams()
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  let location = useLocation()
  const editData = location?.state as any
  const [taxEffectiveList, setTaxEffectiveList] = useState<any>()
  const [invoiceItemData, setInvoiceItemData] = useState([])
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(SnackBarContext)
  const [initDocs, setInitDocs] = useState([])
  const [openExitConf, setOpenExitConf] = useState(null)
  const [openFavoriteDialog, setOpenFavoriteDialog] = useState(false)
  const [detailMode, setDetailMode] = useState('')
  const [creditorAccID, setCreditorAccID] = useState(
    editData ? editData?.CreditorAccountID : null
  )
  const [openFavoriteDeleteDialog, setOpenFavoriteDeleteDialog] = useState(
    false
  )
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [voiceRemark, setVoiceRemark] = useState('')

  const [record, setRecord] = useState(false)
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [edit, setEdit] = useState(false)
  const [docNoChecker, setDocNoChecker] = useState(false)
  const [selectedDOs, setSelectedDOs] = useState<Set<any>>(new Set([]))

  // Expense Item
  const [totalLength, setTotalLength] = useState(0)
  const [expenseItemListing, setExpenseItemListing] = useState([])

  //e-invoice setup for transaction
  const [isSelfBilled, setIsSelfBilled] = useState(
    editData ? editData?.einvoice_self_billed : false
  )

  const [isEinvoice, setIsEinvoice] = useState<boolean>(false)
  const [msicCodeID, setMsicCodeID] = useState(
    editData ? editData?.einvoice_msic_code_id : ''
  )

  const { formMode } = props
  let form, mode
  switch (formMode) {
    case 'add':
      form = 'New'
      mode = 'add'
      break
    case 'edit':
      form = 'Draft'
      mode = 'edit'
      break
    case 'approve-reject':
      form = 'Approve'
      mode = 'approve-reject'
      break
    case 'resubmit':
      form = 'Resubmit'
      mode = 'edit'
      break
  }

  const {
    anchorEl,
    menu,
    handleClick,
    handleClose,
    resetMenu,
  } = useMenuOption()

  const {
    anchorEl: anchorElFav,
    setAnchorEl: setAnchorElFav,
    menu: menuFav,
    handleClick: handleClickFav,
    handleClose: handleCloseFav,
  } = useMenuOption()

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = { getDocumentNumberHeader: [] },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: 'AP_Invoice' },
    onCompleted: ({ getDocumentNumberHeader }) => {
      if (
        (getDocumentNumberHeader?.length > 0 &&
          getDocumentNumberHeader?.find(x => x?.IsAutoDocNo === true)) ||
        getDocumentNumberHeader?.find(x => x?.IsAutoDocNo === true)
      ) {
        setDocNoChecker(true)
      }
    },
  })

  const InvoiceFormSchema = yup.object().shape({
    CreditorAccountID: CommonYupValidation.requireField(
      'Creditor Name is required'
    ),
    Description: CommonYupValidation.requireField(SystemMsgs.description()),
    DocDate: yup.string().required('Doc Date is Required'),
    TrxDate: yup.string().required('Transaction Date is Required'),
    ...(docNoChecker === false
      ? {
          DocNo: yup
            .string()
            .required('Document No. is Required')
            .matches(
              /^(?!\s*$).+/,
              'Entry invalid as field contains space only'
            ),
        }
      : null),
    RefNo: yup.string().required('Reference No is Required'),
    ...(isSelfBilled
      ? {
          MSICCodeID: yup.string().when('isSelfBilled'.toString(), {
            is: true,
            then: yup.string().required(SystemMsgs.MSICCode()),
            otherwise: null,
          }),
        }
      : null),
  })

  const FavInvoiceFormSchema = yup.object().shape({
    Name: CommonYupValidation.requireField(SystemMsgs.name()),
  })

  const {
    handleSubmit,
    register,
    errors,
    control,
    getValues,
    watch,
    setValue,
    clearErrors,
    formState: { isSubmitted },
  } = useForm<APInvoiceProps>({
    mode: 'onSubmit',
    resolver: yupResolver(InvoiceFormSchema),
    defaultValues: {
      UIN: editData ? editData?.einvoice_irbm_uniqueID : null,
      MSICCodeID: editData ? editData?.einvoice_msic_code_id : null,
      isSelfBilled: editData
        ? editData?.einvoice_self_billed
        : !editData?.einvoice_self_billed,
    },
    shouldUnregister: false,
  })
  const {
    handleSubmit: handleFavSubmit,
    register: favRegister,
    control: favControl,
    errors: favErrors,
    watch: favWatch,
  } = useForm<FavInvoiceProps>({
    mode: 'onSubmit',
    resolver: yupResolver(FavInvoiceFormSchema),
  })

  /* -------------------------------------------- */
  /*                    QUERY                     */
  /* -------------------------------------------- */

  let docDate = watch('DocDate') ? new Date(watch('DocDate')) : null
  const {
    loading: CompanyLoading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanyNameQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID, RecordStatus: RecordStatus.Active },
    onCompleted: ({ getCompany }) => {
      fetchEinvComp({
        variables: {
          CompanyID,
          RecordStatus: RecordStatus.Active,
          DocDate: !!watch('DocDate') ? docDate : new Date(),
        },
      })
      fetchCreditorAcc({
        variables: { CompanyID },
      })
    },
  })

  const [
    fetchEinvComp,
    {
      loading: EinvCompStartLoading,
      data: { getCompany: curEinvCompStart } = { getCompany: [] },
    },
  ] = useGetEInvoiceCompanyStartLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RecordStatus: RecordStatus.Active,
      DocDate: !!watch('DocDate') ? docDate : new Date(),
    },
    onCompleted: ({ getCompany }) => {
      setIsEinvoice(curEinvCompStart[0]?.EInvoiceStarted)
    },
  })

  // const {
  //   loading: TaxLoading,
  //   data: { getTaxScheme } = { getTaxScheme: [] },
  // } = useGetTaxSchemeQuery({
  //   onError: error => {
  //     let errorMessage = error.message.substring(15)
  //     console.log('ERROR', error)
  //     setErrorDia(true)
  //     setErrMsg(errorMessage)
  //   },
  // })

  const {
    loading: DocDateValidationLoading,
    data: { getDocumentDateValidation } = { getDocumentDateValidation: [] },
  } = useGetDocumentDateValidationQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
  })

  const {
    loading: msicCodeLoading,
    data: { getMSICCode } = { getMSICCode: [] },
  } = useGetMsicCodeQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
  })

  const [
    fetchCreditorAcc,
    {
      data: { getCreditorAccountCompanyAssignment } = {
        getCreditorAccountCompanyAssignment: [],
      },
      loading: CreditorAccountLoading,
    },
  ] = useGetCreditorAccountCompanyAssignmentNameLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
  })

  let creditorAcc = getCreditorAccountCompanyAssignment?.map(x => {
    return x?.CreditorAccount
  })

  let selectedCreditor = creditorAcc?.filter(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )

  //e-invoice setup for transaction

  let defaultMsicCodeID = creditorAcc?.find(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )?.einvoice_msic_code_id

  // General DO
  const [
    fetchGeneralDos,
    {
      data: { getGeneralDOs } = { getGeneralDOs: [] },
      loading: GeneralDosLoading,
    },
  ] = useGetGeneralDOsLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
  })

  // Item DO
  const [
    fetchDOItem,
    { loading: ItemDosLoading, data: { getDOItem } = { getDOItem: [] } },
  ] = useGetDoItemLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ getDOItem }) => {
      let arry = []
      if (getDOItem?.length > 0) {
        getDOItem?.map((el, index) => {
          const taxAmt = el?.ItemTaxInfo?.reduce(
            (acc, cur) => acc + (cur?.taxAmt || 0),
            0
          )
          arry.push({
            DOHeaderID: el?.DOHeaderID,
            DOItemID: el?.DOItemID,
            UOMID: el?.UOMID,
            ExpenseItemName: el?.ItemName || el?.PurchaseItemName,
            ExpenseItemID: el?.ItemID,
            CostCentreCode: el?.CostCentreCode,
            CostCentreID: el?.CostCentreID,
            Amount: el?.Amount,
            Quantity: Number(parseFloat(el?.Quantity).toFixed(4)),
            UnitPrice: Number(parseFloat(el?.UnitPrice).toFixed(4)),
            DocAmt: el?.Amount + taxAmt,
            TaxSchemeID: el?.TaxSchemeID,
            TaxCode: el?.TaxCode,
            TaxAmt: taxAmt,
            Remark: el?.Remarks,
            einvoice_classification_code_id:
              selectedCreditor[0]?.einvoice_classification_code_id,
            Sequence: index + 1,
            ItemTaxInfo: el?.ItemTaxInfo,
          })
          return el
        })
        setInvoiceItemData(arry)
      }
      if (selectedDOs?.size === 0) setInvoiceItemData([])
    },
  })

  // Item
  const [
    fetchExpenseItem,
    {
      loading: ExpenseItemLoading,
      data: { getItemByCompany } = { getItemByCompany: {} },
    },
  ] = useGetExpenseItemLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    onCompleted: () => {
      setTotalLength(getItemByCompany?.TotalLength)
      setExpenseItemListing(prev => [
        ...new Set([...prev, ...getItemByCompany?.Data]),
      ])
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID, skip: 0, take: 50 },
  })

  const {
    loading: DebtorAccountLoading,
    data: { getDebtorAccountListing } = { getDebtorAccountListing: [] },
  } = useGetDebtorAccountListingQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrorDia(true)
      setErrMsg(error)
    },
    onCompleted: () => {
      if (editData) {
        fetchSalesOrder({
          variables: {
            DebtorAccountID: menu?.obj?.DebtorAccountID,
            excludeSalesOrderID: menu?.obj?.SalesOrderID,
          },
        })
      }
    },
  })

  const [
    fetchSalesOrder,
    {
      loading: SalesOrderLoading,
      data: { getSalesOrderByDebtor } = { getSalesOrderByDebtor: [] },
    },
  ] = useGetSalesOrderByDebtorLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrorDia(true)
      setErrMsg(error)
    },
  })

  const {
    loading: FavoriteInvoiceLoading,
    data: { getAPFavoriteInvoice } = {
      getAPFavoriteInvoice: [],
    },
  } = useGetApFavoriteInvoiceQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID, UserID: user?.ID },
  })

  const favNames = getAPFavoriteInvoice?.map(fav => fav?.Name)

  //CostCentre
  const [
    fetchCostCentre,
    {
      loading: CostCentreLoading,
      data: { getCostCentre } = { getCostCentre: [] },
    },
  ] = useGetCostCentreCodeLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      orderByAsc: 'CostCentreID',
      IsLastNode: true,
    },
  })

  const {
    loading: openPeriodCheckDateLoading,
    data: { latestOpenPeriodCheckingDate } = {
      latestOpenPeriodCheckingDate: {} as any,
    },
  } = useLatestOpenPeriodCheckingDateQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    variables: { CompanyID },
  })

  /* -------------------------------------------- */
  /*                   USEEFECT                   */
  /* -------------------------------------------- */

  useEffect(() => {
    if (formMode === 'edit' && editData) {
      fetchCreditorAcc({
        variables: {
          CompanyID: CompanyID,
        },
      })
      fetchGeneralDos({
        variables: {
          CreditorAccountID: editData?.CreditorAccountID,
          CompanyID,
          InvoiceDate: formatDashDate(
            new Date(editData?.DocDate || new Date()).toISOString()
          ),
          DOItemIDs: editData?.APInvoiceItem?.filter?.(
            y => y?.DOItemID !== null
          )?.map(z => z?.DOItemID),
        },
      })
      const InvoiceItems = editData?.APInvoiceItem?.map((el, index) => {
        return {
          DOHeaderID: el?.DO?.DOHeaderID,
          DOItemID: el?.DOItemID,
          InvoiceItemID: el?.InvoiceItemID,
          ExpenseItemName: el?.ExpenseItem?.ItemName,
          ExpenseItemID: el?.ExpenseItemID,
          CostCentreCode: el?.CostCentre?.Code,
          CostCentreID: el?.CostCentreID,
          Quantity: Number(parseFloat(el?.Quantity).toFixed(4)),
          UnitPrice: Number(parseFloat(el?.UnitPrice).toFixed(4)),
          UOMID: el?.UOMID,
          UOMCode: el?.UOM?.Code,
          Amount: el?.Amount,
          DocAmt: el?.DocAmt,
          TaxSchemeID: el?.TaxSchemeID,
          TaxCode: el?.TaxScheme?.Name,
          TaxAmt: el?.TaxAmt,
          Remark: el?.Remark,
          SalesOrderID: el?.sales_order_id,
          DebtorAccountID: el?.debtor_account_id,
          ItemTaxInfo: el?.ItemTaxInfo,
          einvoice_classification_code_id: el?.einvoice_classification_code_id,
          ClassificationCode: el?.ClassificationCode?.classificationCode,
          ClassificationDescription: el?.ClassificationCode?.description,
          TaxExemptionReason: el?.TaxExemptionReason
            ? el?.TaxExemptionReason
            : null,
          TaxExemptionAmount: el?.TaxExemptionAmount
            ? el?.TaxExemptionAmount
            : null,
          TaxExemptionRate: el?.TaxExemptionRate ? el?.TaxExemptionRate : null,
        }
      })
      invoiceItemData.push(...InvoiceItems)
      if (editData?.DO?.length > 0) {
        editData?.DO?.map(x => selectedDOs.add(x?.DOHeaderID))
      }
    }
  }, [formMode, editData])

  useEffect(() => {
    if (!documentLoading && mode !== 'add') {
      fetchDocuments({ variables: { refID: editData?.InvoiceID } })
    }

    if (editData?.files) {
      setFiles(editData?.files)
      setPreviewFiles(
        editData?.files?.map(file => {
          return URL.createObjectURL(file)
        })
      )
    }
  }, [mode, editData?.InvoiceID, editData])

  useEffect(() => {
    if (editData?.Attachment) {
      setInitDocs(editData?.Attachment)
    }
  }, [editData])

  useEffect(() => {
    if (InvoiceID && editData?.Remark) {
      setValue('Remark', editData?.Remark)
    }
  }, [editData])

  /* -------------------------------------------- */
  /*                  FUNCTION                    */
  /* -------------------------------------------- */

  const [term, setTerm] = useState(
    mode === 'edit' ? editData?.CreditorAccount?.CreditTerm : 0
  )

  let totalAmount = invoiceItemData?.reduce(
    (total, currentValue) => (total = total + currentValue.DocAmt),
    0
  )

  let totalTaxAmt = invoiceItemData?.reduce(
    (total, currentValue) => (total = total + currentValue.TaxAmt),
    0
  )

  let amtBeforeTax = totalAmount - totalTaxAmt

  let calcTotal = items => {
    return items?.reduce(
      (total, currentValue) => (total = total + currentValue.DocAmt),
      0
    )
  }

  const handleAddFavorite = () => {
    setOpenFavoriteDialog(true)
  }

  const handleSelectFavorite = data => {
    setSelectedDOs(new Set([]))
    fetchCreditorAcc({
      variables: {
        CompanyID: CompanyID,
      },
    })
    const favInvItem = data?.APFavoriteInvoiceItem?.map(x => {
      return {
        InvoiceItemID: uuid(),
        ExpenseItemID: x?.ExpenseItemID,
        ExpenseItemName: x?.ExpenseItem?.ItemName,
        CostCentreID: x?.CostCentreID,
        CostCentreCode: x?.CostCentre?.Code,
        UOMID: x?.UOMID,
        UOMCode: x?.UOM?.Code,
        TaxSchemeID: x?.TaxSchemeID,
        TaxCode: x?.TaxScheme?.Name,
        TaxAmt: parseFloat(x?.TaxAmt),
        Amount: parseFloat(x?.Amount),
        DocAmt: parseFloat(x?.DocAmt),
        Quantity: parseFloat(x?.Quantity),
        UnitPrice: parseFloat(x?.UnitPrice),
        Sequence: x?.Sequence,
        Remark: x?.Remark,
        einvoice_classification_code_id: x?.ClassificationCode,
      }
    })
    setInvoiceItemData(favInvItem)
    setValue('RefNo', data?.RefNo)
    setValue('CreditorAccountID', data?.CreditorAccountID)
    setCreditorAccID(data?.CreditorAccountID)
    setValue('Remark', data?.Remark)
    setValue('DocAmt', data?.DocAmt)
    setValue('Description', data?.Description)
    handleCreditorChange(watch('CreditorAccountID'))
  }

  const updateNewInvoiceItem = (newDate, TEList) => {
    const arr = []
    invoiceItemData?.map(x => {
      arr.push({
        DOItemID: x?.DOItemID,
        InvoiceItemID: x?.InvoiceItemID,
        ExpenseItemID: x?.ExpenseItemID,
        RevenueCode: x?.RevenueCode,
        RevenueName: x?.RevenueName,
        Amount: x?.Amount,
        TaxSchemeID: x?.ExpenseItem?.TaxSchemeID,
        TaxSchemeName: x?.TaxSchemeName,
        TaxAmt: x?.TaxAmt,
        DocAmt: x?.DocAmt,
        CostCentreID: x?.CostCentreID,
        CostCentreCode: x?.CostCentreCode,
        SalesOrderID: x?.SalesOrderID,
        DebtorAccountID: x?.DebtorAccountID,
        Remark: x?.Remark,
      })
    })
  }

  const [selectedTax, setSelectedTax] = useState(null)

  const handleCheckBoxChange = (event: any) => {
    let temp = selectedDOs || new Set()
    if (event?.target?.checked) {
      temp.add(event?.target?.value)
      setSelectedDOs(new Set(temp))
      fetchDOItem({ variables: { DOHeaderID: Array.from(selectedDOs) } })
    } else {
      temp.delete(event?.target?.value)
      setSelectedDOs(new Set(temp))
      // setInvoiceItemData([])
    }
    fetchDOItem({ variables: { DOHeaderID: Array.from(selectedDOs) } })
  }

  const readOnly = () => {
    if (menu?.obj?.DOItemID || menu?.obj?.GRTNItemID) return true
    else return false
  }

  //this is to check self bill setup from creditor account
  const handleCreditorChange = event => {
    setSelectedDOs(new Set([]))
    let selfBilled = creditorAcc?.find(x => x?.CreditorAccountID === event)
      ?.einvoice_self_billed
    if (
      new Date(watch('DocDate')).toISOString() <
        curEinvCompStart[0]?.eInvStartDate ||
      curEinvCompStart[0]?.EInvoiceStarted === false
    )
      setIsSelfBilled(false)
    else {
      register('isSelfBilled')
      setValue('isSelfBilled', selfBilled)
      setIsSelfBilled(selfBilled)
    }
    let defaultMsicCodeID = creditorAcc?.find(
      x => x?.CreditorAccountID === event
    )?.einvoice_msic_code_id
    register('MSICCodeID')
    setValue('MSICCodeID', defaultMsicCodeID)
    setMsicCodeID(defaultMsicCodeID)
  }

  let selfBilled = creditorAcc?.find(
    x => x?.CreditorAccountID === watch('CreditorAccountID')
  )?.einvoice_self_billed

  //this is for toggle self bill e-invoice
  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue('isSelfBilled', e.target.checked)
    setIsSelfBilled(e.target.checked)
  }

  /* -------------------------------------------- */
  /*         CREATE & UPDATE MUTATION             */
  /* -------------------------------------------- */

  const [
    createAPInvoice,
    { loading: createAPInvoiceLoading, called: createAPInvoiceCalled },
  ] = useCreateApInvoiceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        history.push({ pathname: `/account-payable/${CompanyID}/invoice` })
      }, 500)
    },
  })

  const [
    updateAPInvoice,
    { loading: updateAPInvoiceLoading, called: updateAPInvoiceCalled },
  ] = useUpdateApInvoiceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setTimeout(() => {
        history.push({ pathname: `/account-payable/${CompanyID}/invoice` })
      }, 500)
    },
  })

  const [
    createApFavoriteInvoice,
    { loading: createFavoriteInvoiceLoading },
  ] = useCreateApFavoriteInvoiceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setOpenFavoriteDialog(false)
    },
  })

  const checkSetupNumStruc = () => {
    if (
      getDocumentNumberHeader?.length > 0 &&
      getDocumentNumberHeader?.find(x => x?.IsAutoDocNo === true) &&
      getDocumentNumberHeader[0]?.SampleOutput === ''
    ) {
      return true
    } else return false
  }

  //checking for existing docNo
  const watchDocNo = watch('DocNo')

  const existingDocNo = creditorAcc?.find(
    x =>
      x?.CreditorAccountID === watch('CreditorAccountID') &&
      x?.RecordStatus === 'ACTIVE'
  )?.DocNoList

  /* -------------------------------------------- */
  /*                  ATTACHMENT                  */
  /* -------------------------------------------- */

  const {
    files,
    setFiles,
    setPreviewFiles,
    handleUploadChange,
    previewFiles,
    remove: removeFile,
    handleEditUpload,
  } = useUploadAttachment()

  const [
    fetchDocuments,
    { loading: documentLoading, data: DocData },
  ] = useDocumentListingLazyQuery({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    fetchPolicy: 'network-only',
    onCompleted: ({ DocumentListing }) => {
      // only applies when first opening edit form, when editData still does not have "files" but only Attachment from field resolver
      if (!editData?.files) {
        handleEditUpload(
          DocumentListing?.filter(doc => doc?.description !== 'document_pdf')
        )
        previewFiles?.push(
          ...DocumentListing?.filter(
            doc => doc?.description !== 'document_pdf'
          )?.map(x => x?.fileURL)
        )
      }
    },
  })

  /* -------------------------------------------- */
  /*                   DELETE                     */
  /* -------------------------------------------- */

  const onDeleteInvoiceItem = (delInd: number) => {
    invoiceItemData.splice(delInd, 1)
  }

  const [
    deleteAPFavoriteInvoice,
    { loading: deleteFavoriteInvoiceLoading },
  ] = useDeleteApFavoriteInvoiceMutation({
    onError: error => {
      let errorMessage = error.message.substring(15)
      console.log('ERROR', error)
      setErrorDia(true)
      setErrMsg(errorMessage)
      setIsSavingDraft(false)
      setIsSubmitting(false)
      setIsRejectSave(false)
    },
    onCompleted: data => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOpenFavoriteDeleteDialog(false)
    },
    variables: { FavoriteInvoiceID: menuFav?.ID },
  })

  /* -------------------------------------------- */
  /*                  ONSUBMIT                    */
  /* -------------------------------------------- */

  const onSubmit = (data, status) => {
    if (formMode === 'add') {
      if (
        // getDocumentNumberHeader?.filter(x => x?.RefTable === 'AP_Invoice')
        //   ?.length === 0
        checkSetupNumStruc() === true
      ) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.errorNumberingStructure())
      }
      if (
        findDuplicates(existingDocNo, watchDocNo, formMode, editData?.DocNo)
      ) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.duplicateDocNo())
      } else {
        //add the data with GraphQL mutation
        createAPInvoice({
          variables: {
            input: {
              InvoiceID: InvoiceID,
              CompanyID: CompanyID,
              DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
              TransactionDate: formatDashDate(
                new Date(data?.TrxDate)?.toISOString()
              ),
              DueDate: new Date(
                dueDateChecker(data?.DocDate, term)
              ).toISOString(),
              Remark: data?.Remark,
              ApprovalStatus: statusInput(status),
              Attachment: files,
              CreditorAccountID: data?.CreditorAccountID,
              // debtor_account_id: data?.DebtorAccountID || null,
              // sales_order_id: data?.SalesOrderID || null,
              Description: data.Description,
              CreditTerm: term,
              // DocAmt: totalAmount ?? 0,
              DocAmt: totalAmount ?? 0,
              ...(docNoChecker === false ? { DocNo: data.DocNo } : null),
              RefNo: data?.RefNo,
              DocAmtBeforeTax: amtBeforeTax ?? 0,
              einvoice_irbm_uniqueID: data?.UIN,
              einvoice_self_billed: isSelfBilled,
              ...(isSelfBilled ? { einvoice_msic_code_id: msicCodeID } : null),
            },
            itemInput: invoiceItemData?.map((x, i) => {
              const itemTaxInput =
                x?.ItemTaxInfo && x.ItemTaxInfo.length > 0
                  ? x.ItemTaxInfo.map(tax => ({
                      tax_amt: tax.taxAmt,
                      tax_rate: tax.taxRate,
                      tax_id: tax.taxId,
                      tax_scheme_detail_id: tax.taxSchemeDetailId,
                      tax_scheme_id: tax.taxSchemeId,
                    }))
                  : []

              return {
                ...(!!x?.DOItemID ? { DOItemID: x?.DOItemID } : null),
                ExpenseItemID: x?.ExpenseItemID,
                Amount: parseFloat(x?.Amount),
                TaxSchemeID: x?.TaxSchemeID,
                TaxAmt: parseFloat(x?.TaxAmt),
                DocAmt: parseFloat(x?.DocAmt),
                Quantity: Number(parseFloat(x?.Quantity).toFixed(4)),
                UnitPrice: Number(parseFloat(x.UnitPrice).toFixed(4)),
                UOMID: x?.UOMID,
                CostCentreID: x?.CostCentreID,
                Remark: x?.Remark,
                sales_order_id: x?.SalesOrderID,
                debtor_account_id: x?.DebtorAccountID,
                Sequence: x?.Sequence ?? i + 1,
                itemTaxInput: itemTaxInput,
                einvoice_classification_code_id:
                  x?.einvoice_classification_code_id,
                TaxExemptionReason: x?.TaxExemptionReason ?? null,
                TaxExemptionAmount: x?.TaxExemptionAmount ?? null,
                TaxExemptionRate: x?.TaxExemptionRate ?? null,
              }
            }),
          },
          refetchQueries: [
            {
              query: GetApInvoiceDocument,
              variables: {
                CompanyID: CompanyID,
                StatusArr: ['ACTIVE'],
              },
            },
            {
              query: DocumentListingDocument,
              variables: {
                refTable: 'S_Attachment',
                refID: editData?.InvoiceID,
              },
            },
          ],
        })
      }
    } else if (formMode !== 'add') {
      //update the data
      if (
        findDuplicates(existingDocNo, watchDocNo, formMode, editData?.DocNo)
      ) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.duplicateDocNo())
      } else {
        updateAPInvoice({
          variables: {
            input: {
              InvoiceID: InvoiceID,
              CompanyID: CompanyID,
              DocDate: formatDashDate(new Date(data?.DocDate)?.toISOString()),
              TransactionDate: formatDashDate(
                new Date(data?.TrxDate)?.toISOString()
              ),
              ...(docNoChecker === false ? { DocNo: data.DocNo } : null),
              RefNo: data?.RefNo,
              Remark: data?.Remark,
              ApprovalStatus: statusInput(status),
              Attachment: files,
              CreditorAccountID: data?.CreditorAccountID,
              // debtor_account_id: data?.DebtorAccountID || null,
              // sales_order_id: data?.SalesOrderID || null,
              DocAmt: totalAmount ?? 0,
              Description: data.Description,
              CreditTerm: term,
              DueDate: new Date(
                dueDateChecker(data?.DocDate, term)
              ).toISOString(),
              DocAmtBeforeTax: amtBeforeTax ?? 0,
              einvoice_irbm_uniqueID: data?.UIN,
              einvoice_self_billed: isSelfBilled,
              ...(isSelfBilled ? { einvoice_msic_code_id: msicCodeID } : null),
            },
            itemInput: invoiceItemData?.map((x, index) => {
              const itemTaxInput =
                x?.ItemTaxInfo && x.ItemTaxInfo.length > 0
                  ? x.ItemTaxInfo.map(tax => ({
                      tax_amt: tax.taxAmt,
                      tax_rate: tax.taxRate,
                      tax_id: tax.taxId,
                      tax_scheme_detail_id: tax.taxSchemeDetailId,
                      tax_scheme_id: tax.taxSchemeId,
                    }))
                  : []

              return {
                ...(!!x?.DOItemID ? { DOItemID: x?.DOItemID } : null),
                ExpenseItemID: x?.ExpenseItemID,
                Amount: parseFloat(x?.Amount),
                TaxSchemeID: x?.TaxSchemeID,
                TaxAmt: parseFloat(x?.TaxAmt),
                DocAmt: parseFloat(x?.DocAmt),
                Quantity: Number(parseFloat(x?.Quantity).toFixed(4)),
                UnitPrice: Number(parseFloat(x.UnitPrice).toFixed(4)),
                UOMID: x?.UOMID,
                CostCentreID: x?.CostCentreID,
                Remark: x?.Remark,
                sales_order_id: x?.SalesOrderID,
                debtor_account_id: x?.DebtorAccountID,
                Sequence: x?.Sequence ?? index + 1,
                itemTaxInput: itemTaxInput,
                einvoice_classification_code_id:
                  x?.einvoice_classification_code_id,
                TaxExemptionReason: x?.TaxExemptionReason ?? null,
                TaxExemptionAmount: x?.TaxExemptionAmount ?? null,
                TaxExemptionRate: x?.TaxExemptionRate ?? null,
              }
            }),
          },
          refetchQueries: [
            {
              query: GetApInvoicebyStatusDocument,
              variables: {
                CompanyID: CompanyID,
                StatusArr: ['ACTIVE'],
              },
            },
            {
              query: DocumentListingDocument,
              variables: {
                refTable: 'S_Attachment',
                refID: editData?.InvoiceID,
              },
            },
          ],
        })
      }
    }
  }

  const favRefetchQuery = [
    {
      query: GetApFavoriteInvoiceDocument,
      variables: {
        CompanyID,
        UserID: user?.ID,
      },
    },
  ]

  const onSubmitFavorite = data => {
    const tempFav = {
      Name: data?.Name,
      UserID: user?.ID,
      InvoiceID: !!getValues('InvoiceID') ? getValues('InvoiceID') : null,
      Remark: !!getValues('Remark') ? getValues('Remark') : null,
      CreditorAccountID: !!getValues('CreditorAccountID')
        ? getValues('CreditorAccountID')
        : null,
      Description: !!getValues('Description') ? getValues('Description') : null,
      RefNo: !!getValues('RefNo') ? getValues('RefNo') : null,
      DocAmt: !!getValues('DocAmt') ? getValues('DocAmt') : 0,
      DocDate: !!getValues('DocDate') ? getValues('DocDate') : null,
    }
    const invItem: any[] = invoiceItemData
    const tempFavItem = invItem?.map(x => {
      return {
        ExpenseItemID: x?.ExpenseItemID,
        CostCentreID: x?.CostCentreID,
        TaxSchemeID: x?.TaxSchemeID,
        UOMID: x?.UOMID,
        TaxAmt: parseFloat(x?.TaxAmt),
        Amount: parseFloat(x?.Amount),
        DocAmt: parseFloat(x?.DocAmt),
        Quantity: Number(parseFloat(x?.Quantity).toFixed(4)),
        UnitPrice: Number(parseFloat(x.UnitPrice).toFixed(4)),
        Sequence: x?.Sequence,
        Remark: x?.Remark,
        ClassificationCode:
          selectedCreditor[0]?.einvoice_classification_code_id,
      }
    })
    createApFavoriteInvoice({
      variables: {
        APFavoriteInvoiceInput: tempFav,
        APFavoriteInvoiceItemInput: tempFavItem,
      },
      refetchQueries: favRefetchQuery,
    })
  }

  /* -------------------------------------------- */
  /*               DOC DATE VALIDATION            */
  /* -------------------------------------------- */
  const DocDate = watch('DocDate') ? new Date(watch('DocDate')) : null
  const today = new Date()

  const monthsBefore = getDocumentDateValidation?.[0]?.MonthsBefore ?? 12
  const monthsAfter = getDocumentDateValidation?.[0]?.MonthsAfter ?? 1

  // Calculate valid range
  const minValidDate = new Date(today)
  minValidDate.setMonth(minValidDate.getMonth() - monthsBefore)
  minValidDate.setHours(0, 0, 0, 0)

  const maxValidDate = new Date(today)
  maxValidDate.setMonth(maxValidDate.getMonth() + monthsAfter)
  maxValidDate.setHours(23, 59, 59, 999)

  // Validate inclusive range
  const isDocDateInvalid =
    DocDate &&
    (DocDate.getTime() < minValidDate.getTime() ||
      DocDate.getTime() > maxValidDate.getTime())

  /* -------------------------------------------- */
  /*               EXIT CONFIRMATION              */
  /* -------------------------------------------- */
  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: editData,
      itemArr: invoiceItemData,
      initFiles: initDocs,
      currFiles: files?.map(file => file?.name),
      itemSuffixID: 'InvoiceItemID',
      itemTableName: 'APInvoiceItem',
      formMode: formMode,
    })

  const { handlePermDisabled } = usePermissionChecker()

  const createUpdateLoading = editData
    ? updateAPInvoiceLoading
    : createAPInvoiceLoading
  const createUpdateCalled = editData
    ? updateAPInvoiceCalled
    : createAPInvoiceCalled

  const docDateTimestamp = new Date(watch('DocDate'))
  const yearDocDate = docDateTimestamp.getFullYear()
  const monthDocDate = (docDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayDocDate = docDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const transferDate = `${yearDocDate}-${monthDocDate}-${dayDocDate}`

  const trxDateTimestamp = new Date(watch('TrxDate'))
  const yearTrxDate = trxDateTimestamp.getFullYear()
  const monthTrxDate = (trxDateTimestamp.getMonth() + 1)
    .toString()
    .padStart(2, '0')
  const dayTrxDate = trxDateTimestamp
    .getDate()
    .toString()
    .padStart(2, '0')

  const trxDate = `${yearTrxDate}-${monthTrxDate}-${dayTrxDate}`

  const openPeriod1 =
    transferDate <= latestOpenPeriodCheckingDate?.StartDate ||
    transferDate >= latestOpenPeriodCheckingDate?.EndDate

  const openPeriod2 =
    trxDate >= latestOpenPeriodCheckingDate?.StartDate &&
    trxDate <= latestOpenPeriodCheckingDate?.EndDate

  const checkingYearClose1 = openPeriod1 ? true : false
  const checkingYearClose2 = openPeriod2 ? false : true

  /* -------------------------------------------- */
  /*                    FOOTER                    */
  /* -------------------------------------------- */

  // ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ - Loading feedback and  block multiple entry  - ✥✥✥✥✥✥✥✥✥✥✥✥✥✥ //

  const [isSavingDraft, setIsSavingDraft] = useState(false)

  const handleDraftClick = () => {
    setIsSavingDraft(true)
    setTimeout(() => {
      handleSubmit(
        async data => {
          try {
            onSubmit(data, 'draft')
          } catch (err) {
            setIsSavingDraft(false)
          }
        },
        () => {
          setIsSavingDraft(false)
        }
      )()
    }, 0)
  }

  const draftFooterOption = {
    name: isSavingDraft ? <CircularProgress size="20px" /> : 'Save as Draft',
    // onClick: () => {
    //   handleSubmit(data => !createUpdateLoading && onSubmit(data, 'draft'))()
    // },
    onClick: handleDraftClick,
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      isSavingDraft || checkingYearClose2 || isDocDateInvalid
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccPayableInvoicesDraft,
          }),
  }

  const [isRejectSave, setIsRejectSave] = useState(false)

  const handleSaveClick = () => {
    setIsRejectSave(true)
    setTimeout(() => {
      handleSubmit(
        async data => {
          try {
            onSubmit(data, 'reject')
          } catch (err) {
            setIsRejectSave(false)
          }
        },
        () => {
          setIsRejectSave(false)
        }
      )()
    }, 0)
  }

  const rejectFooterOption = {
    name: isRejectSave ? <CircularProgress size="20px" /> : 'Save',
    // onClick: () => {
    //   handleSubmit(data => !createUpdateLoading && onSubmit(data, 'reject'))()
    // },
    onClick: handleSaveClick,
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      isRejectSave ||
      !!errors?.DocDate ||
      !!errors?.TrxDate ||
      !!errors?.RefNo ||
      !!errors?.CreditorAccountID ||
      !!errors?.Description ||
      checkingYearClose2 ||
      isDocDateInvalid
        ? true
        : handlePermDisabled({
            companyID: CompanyID,
            permEnum: AcctPermission.AccPayableInvoicesUpdate,
          }),
  }

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmitClick = () => {
    setIsSubmitting(true)
    setTimeout(() => {
      handleSubmit(
        async data => {
          try {
            onSubmit(data, 'submit')
          } catch (err) {
            setIsSubmitting(false)
          }
        },
        () => {
          setIsSubmitting(false)
        }
      )()
    }, 0)
  }

  const submitFooterOption = {
    name: isSubmitting ? <CircularProgress size="20px" /> : 'Submit',
    // onClick: () => {
    //   handleSubmit(data => !createUpdateCalled && onSubmit(data, 'submit'))()
    // },
    onClick: handleSubmitClick,
    color: 'primary',
    props: {
      type: 'submit',
    },
    disabled:
      isSubmitting ||
      calcTotal(invoiceItemData) === 0 ||
      calcTotal(invoiceItemData) === undefined ||
      isDocDateInvalid ||
      checkingYearClose2 === true
        ? true
        : false,
  }

  let footerOptions: any[]
  if (editData?.mode === 'resubmit') {
    footerOptions = [rejectFooterOption, submitFooterOption]
  } else {
    footerOptions = [draftFooterOption, submitFooterOption]
  }

  useEffect(() => {
    if (openDialog) {
      localStorage.setItem(
        'invoice',
        JSON.stringify({ DocDate: getValues('DocDate') })
      )
    } else {
      localStorage.removeItem('invoice')
    }
  }, [openDialog, getValues])

  const invoiceHeader = JSON.parse(localStorage.getItem('invoice'))

  const creditorID = watch('CreditorAccountID')

  useEffect(() => {
    if (!creditorID) return

    // find the full object
    const matched = creditorAcc?.find(x => x?.CreditorAccountID === creditorID)

    if (!matched) return

    // Use a microtask to prevent immediate re-render loop
    Promise.resolve().then(() => {
      handleCreditorChange(matched?.CreditorAccountID)
      setTerm(matched?.CreditTerm)
      clearErrors('CreditorAccountID')
      setSelectedDOs(new Set([]))
      setInvoiceItemData([])

      fetchGeneralDos({
        variables: {
          CreditorAccountID: matched?.CreditorAccountID,
          CompanyID,
          InvoiceDate: formatDashDate(
            new Date(watch('DocDate') || new Date()).toISOString()
          ),
          DOItemIDs: editData?.APInvoiceItem?.filter(
            y => y?.DOItemID !== null
          )?.map(z => z?.DOItemID),
        },
      })
    })
  }, [creditorID])

  return (
    <>
      {CompanyLoading && <Loading />}
      {ItemDosLoading && <Loading />}
      {documentLoading && <Loading />}
      {msicCodeLoading && <Loading />}
      {SalesOrderLoading && <Loading />}
      {GeneralDosLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {/* {DebtorAccountLoading && <Loading />} */}
      {EinvCompStartLoading && <Loading />}
      {CreditorAccountLoading && <Loading />}
      {FavoriteInvoiceLoading && <Loading />}
      {DocDateValidationLoading && <Loading />}
      {openPeriodCheckDateLoading && <Loading />}
      {createFavoriteInvoiceLoading && <Loading />}
      {deleteFavoriteInvoiceLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => {
          if (hasChanges() === true) {
            setOpenExitConf(true)
          } else {
            history.push({
              pathname: `/account-payable/${CompanyID}/invoice`,
            })
          }
        }}
        smTitle={'Account Payable'}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'Accounts Payable Main Menu' },
          { name: 'Accounts Payable Submenu' },
          { name: 'Invoice', current: true },
        ]}
        rightRouteSegments={[
          {
            name:
              formMode === 'add'
                ? 'New'
                : formMode === 'approve-reject'
                ? 'Approve/Reject'
                : formMode === 'edit'
                ? 'Edit'
                : 'Draft',
            current: true,
          },
        ]}
      />

      <ContentWrapper float footer>
        <CardContents
          section={{
            header: {
              title: 'Invoice',
              icon:
                formMode === 'add' || formMode === 'edit' ? (
                  <>
                    <FavoriteMenu
                      options={getAPFavoriteInvoice}
                      funcLabel={'Add Favorite'}
                      addFavFunc={handleAddFavorite}
                      selectFavFunc={handleSelectFavorite}
                      optionIDName={'FavoriteInvoiceID'}
                      setOpenFavoriteDeleteDialog={setOpenFavoriteDeleteDialog}
                      anchorEl={anchorElFav}
                      setAnchorEl={setAnchorElFav}
                      handleClose={handleCloseFav}
                      handleClickDelete={handleClickFav}
                    />

                    {formMode === 'edit' && (
                      <IconText
                        icon={
                          <img
                            src={AuditLog}
                            style={{
                              width: '17px',
                              marginRight: '5px',
                              marginLeft: '12px',
                            }}
                            onClick={() => {
                              history.push({
                                pathname: `/account-payable/${CompanyID}/invoice/${InvoiceID}/detail/audit-log`,
                                state: {
                                  ID: editData?.InvoiceID,
                                  tableName: 'AP_Invoice',
                                  primaryKey: 'InvoiceID',
                                  primaryItemKey: 'InvoiceItemID',
                                  ...editData,
                                },
                              })
                            }}
                          />
                        }
                        font="desc"
                      ></IconText>
                    )}
                  </>
                ) : null,
            },
          }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              name="DocDate"
              control={control}
              defaultValue={editData ? editData?.DocDate : new Date()}
              rules={{ required: true }}
              render={({ onChange, value }) => (
                <KeyboardDatePicker
                  required
                  label="Invoice Date"
                  format="dd/MM/yyyy"
                  value={
                    value ||
                    (formMode === 'add' ? new Date() : editData?.DocDate)
                  }
                  onChange={(date: Date | null) => {
                    onChange(date)

                    if (
                      date &&
                      !isNaN(date.getTime()) &&
                      watch('CreditorAccountID')
                    ) {
                      fetchGeneralDos({
                        variables: {
                          CreditorAccountID: watch('CreditorAccountID'),
                          CompanyID,
                          InvoiceDate: formatDashDate(
                            new Date(date).toISOString()
                          ),
                          DOItemIDs: editData?.APInvoiceItem?.filter(
                            y => y?.DOItemID !== null
                          )?.map(z => z?.DOItemID),
                        },
                      })
                    }
                  }}
                  onAccept={(date: Date | null) => {
                    updateNewInvoiceItem(date, taxEffectiveList)
                    fetchEinvComp({
                      variables: {
                        CompanyID: CompanyID,
                        RecordStatus: RecordStatus.Active,
                        DocDate: date,
                      },
                    })

                    if (watch('CreditorAccountID')) {
                      fetchGeneralDos({
                        variables: {
                          CreditorAccountID: watch('CreditorAccountID'),
                          CompanyID,
                          InvoiceDate: formatDashDate(
                            new Date(date || new Date()).toISOString()
                          ),
                          DOItemIDs: editData?.APInvoiceItem?.filter(
                            y => y?.DOItemID !== null
                          )?.map(z => z?.DOItemID),
                        },
                      })
                    }

                    const selfBilled = creditorAcc?.find(
                      x => x?.CreditorAccountID === watch('CreditorAccountID')
                    )?.einvoice_self_billed
                    const defaultMsicCodeID = creditorAcc?.find(
                      x => x?.CreditorAccountID === watch('CreditorAccountID')
                    )?.einvoice_msic_code_id

                    if (
                      date &&
                      new Date(date).toISOString() <
                        curEinvCompStart[0]?.eInvStartDate
                    ) {
                      setIsSelfBilled(false)
                    } else {
                      register('isSelfBilled')
                      setValue('isSelfBilled', selfBilled)
                      setIsSelfBilled(selfBilled)
                      setValue('MSICCodeID', defaultMsicCodeID)
                      setMsicCodeID(defaultMsicCodeID)
                    }
                  }}
                  margin="dense"
                  allowKeyboardControl
                  ref={register}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  defaultValue={editData ? editData?.DocDate : new Date()}
                  showTodayButton
                  disabled={formMode === 'approve-reject'}
                  className=" left"
                  minDate={minValidDate}
                  maxDate={maxValidDate}
                  helperText={
                    isDocDateInvalid
                      ? 'Document date is not within the validation range'
                      : errors?.DocDate?.message
                  }
                  error={!!errors?.DocDate || isDocDateInvalid}
                />
              )}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Controller
              as={KeyboardDatePicker}
              name="TrxDate"
              required
              label="Transaction Date"
              control={control}
              format="dd/MM/yyyy"
              margin="dense"
              allowKeyboardControl
              onChange={(date: Date | null) => {}}
              ref={register}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              showTodayButton
              className="right"
              value={new Date()}
              defaultValue={editData ? editData?.TransactionDate : new Date()}
              minDate={new Date(latestOpenPeriodCheckingDate?.StartDate)}
              maxDate={new Date(latestOpenPeriodCheckingDate?.EndDate)}
              helperText={
                checkingYearClose2
                  ? 'Financial Period already closed'
                  : errors?.TrxDate?.message
              }
              error={errors?.TrxDate || checkingYearClose2 ? true : false}
            />
          </MuiPickersUtilsProvider>
          {!docNumHeaderLoading && (
            <>
              {docNoChecker === false ||
              getDocumentNumberHeader[0]?.IsAutoDocNo === false ? (
                <Controller
                  as={TextField}
                  name="DocNo"
                  label="Document No"
                  margin="dense"
                  required
                  id="standard-basic"
                  defaultValue={editData?.DocNo}
                  autoComplete="off"
                  control={control}
                  className="left"
                  ref={register}
                  helperText={errors?.DocNo?.message}
                  error={errors?.DocNo ? true : false}
                />
              ) : null}
            </>
          )}
          <Controller
            as={TextField}
            id="standard-basic"
            name="RefNo"
            label="Reference No."
            required
            autoComplete="off"
            control={control}
            className={
              docNoChecker === false ||
              getDocumentNumberHeader[0]?.IsAutoDocNo === false
                ? 'right'
                : ''
            }
            fullWidth={
              docNoChecker === false ||
              getDocumentNumberHeader[0]?.IsAutoDocNo === false
                ? true
                : false
            }
            margin="dense"
            ref={register}
            helperText={errors?.RefNo?.message}
            error={errors?.RefNo ? true : false}
            defaultValue={editData ? editData?.RefNo : ''}
            disabled={mode == 'approve-reject'}
          />
          <Controller
            as={TextField}
            id="standard-basic"
            name="UIN"
            label="UIN"
            // required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            ref={register}
            helperText={errors?.UIN?.message}
            error={errors?.UIN ? true : false}
            defaultValue={editData ? editData?.einvoice_irbm_uniqueID : ''}
          />

          {!CreditorAccountLoading && (
            <Controller
              render={({ value, onChange }) => {
                const selectedVal =
                  creditorAcc?.find(x => x?.CreditorAccountID === value) || null

                return (
                  <Autocomplete
                    options={
                      creditorAcc?.sort((a, b) => {
                        return a?.CompanyName?.localeCompare(b?.CompanyName)
                      }) || []
                    }
                    getOptionLabel={option => `${option?.CompanyName}`}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      handleCreditorChange(newValue?.CreditorAccountID)
                      setValue('CreditorAccountID', newValue?.CreditorAccountID)
                      setTerm(newValue?.CreditTerm)
                      clearErrors('CreditorAccountID')
                      setSelectedDOs(new Set([]))
                      setInvoiceItemData([])
                      if (newValue?.CreditorAccountID) {
                        fetchGeneralDos({
                          variables: {
                            CreditorAccountID: !!watch(`CreditorAccountID`)
                              ? watch(`CreditorAccountID`)
                              : newValue?.CreditorAccountID,
                            CompanyID,
                            InvoiceDate: formatDashDate(
                              new Date(
                                watch('DocDate') || new Date()
                              ).toISOString()
                            ),
                            DOItemIDs: editData?.APInvoiceItem?.filter(
                              y => y?.DOItemID !== null
                            )?.map(z => z?.DOItemID),
                          },
                        })
                      }
                    }}
                    renderOption={(props, option) => {
                      return <span>{props?.CompanyName}</span>
                    }}
                    value={selectedVal}
                    disabled={mode === 'approve-reject'}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.CreditorAccountID?.message}
                            error={errors?.CreditorAccountID ? true : false}
                            label="Creditor Name"
                            style={{ width: '100%' }}
                            margin="dense"
                            required
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Creditor Name"
              name="CreditorAccountID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="dense"
              ref={register}
              helperText={errors?.CreditorAccountID?.message}
              error={errors?.CreditorAccountID ? true : false}
              defaultValue={editData?.CreditorAccountID ?? creditorAccID}
              required
              disabled={mode === 'approve-reject'}
            />
          )}
          {/* 
          {!DebtorAccountLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = getDebtorAccount?.filter(
                  coa => coa?.DebtorAccountID === editData?.debtor_account_id
                )[0]

                return (
                  <Autocomplete
                    ref={register}
                    options={
                      getDebtorAccount?.sort((a, b) => {
                        return a?.DebtorName?.localeCompare(b?.DebtorName)
                      }) || []
                    }
                    getOptionLabel={option => {
                      return `${option?.DebtorName}`
                    }}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('DebtorAccountID', newValue?.DebtorAccountID)
                      fetchSalesOrder({
                        variables: {
                          DebtorAccountID: newValue?.DebtorAccountID ?? null,
                        },
                      })
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderOption={(props, option) => {
                      return (
                        <div>
                          <div>
                            <span className="xsTitle">{props?.DebtorName}</span>
                          </div>
                        </div>
                      )
                    }}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.DebtorAccountID?.message}
                            error={errors?.DebtorAccountID ? true : false}
                            label="Customer Name"
                            style={{
                              width: '100%',
                            }}
                            margin="normal"
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Customer Name"
              name="DebtorAccountID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="normal"
              ref={register}
              helperText={errors?.DebtorAccountID?.message}
              error={errors?.DebtorAccountID ? true : false}
              defaultValue={editData ? editData?.debtor_account_id : ''}
            />
          )} */}
          {/* {!SalesOrderLoading && (
            <Controller
              render={({ value, onChange }) => {
                const defVal = getSalesOrderByDebtor?.filter(
                  coa => coa?.id === editData?.sales_order_id
                )[0]

                return (
                  <Autocomplete
                    options={getSalesOrderByDebtor || []}
                    getOptionLabel={option => {
                      const revised = option?.revisedOrderSum
                      const fallback = option?.orderSum
                      const amount = revised
                        ? amtStr(revised)
                        : amtStr(fallback)
                      return `${option?.title || 'N/A'} | ${amount || 'N/A'}`
                    }}
                    fullWidth
                    onChange={(value, newValue: any) => {
                      setValue('SalesOrderID', newValue?.id)
                    }}
                    defaultValue={defVal}
                    disabled={mode === 'approve-reject'}
                    renderOption={(props, option) => (
                      <Fragment>
                        <ListItemText
                          primary={
                            <Grid container>
                              <Grid
                                item
                                xs={8}
                                component="span"
                                className="xsTitle "
                              >
                                {props?.title || 'N/A'}
                              </Grid>
                              <Grid
                                item
                                xs={4}
                                component="span"
                                className="xsTitle right-text highlight-text"
                              >
                                {amtStr(
                                  props?.revisedOrderSum ?? props?.orderSum
                                )}
                              </Grid>
                            </Grid>
                          }
                        />
                      </Fragment>
                    )}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            helperText={errors?.SalesOrderID?.message}
                            error={errors?.SalesOrderID ? true : false}
                            label="Sales Order"
                            style={{ width: '100%' }}
                            margin="normal"
                            defaultValue={defVal}
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              label="Sales Order"
              name="SalesOrderID"
              autoComplete="off"
              control={control}
              multiline={true}
              fullWidth
              margin="normal"
              ref={register}
              helperText={errors?.SalesOrderID?.message}
              error={errors?.SalesOrderID ? true : false}
              defaultValue={
                !!watch('DebtorAccountID')
                  ? editData?.sales_order_id
                  : undefined
              }
            />
          )} */}
          {!GeneralDosLoading && (
            <Controller
              render={({ value, onChange }) => {
                return (
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={
                      getGeneralDOs?.sort((a, b) => {
                        return a?.DocNo?.localeCompare(b?.DocNo)
                      }) || []
                    }
                    getOptionLabel={option => `${option?.DocNo}`}
                    fullWidth
                    onChange={(event, value, reason) => {
                      const updatedSelected = new Set<string>()
                      value?.forEach(x => updatedSelected.add(x?.DOHeaderID))

                      if (reason === 'remove-option') {
                        value?.forEach(x => {
                          updatedSelected.add(x?.DOHeaderID)
                        })
                      } else if (reason === 'clear') {
                        setSelectedDOs(new Set())
                        setInvoiceItemData([])
                        return
                      } else {
                        value?.forEach(x => {
                          updatedSelected.add(x?.DOHeaderID)
                        })
                      }

                      setSelectedDOs(new Set(updatedSelected))

                      fetchDOItem({
                        variables: {
                          DOHeaderID: Array.from(updatedSelected),
                        },
                      })
                    }}
                    defaultValue={editData?.DO}
                    renderOption={(option, { selected }) => (
                      <Fragment>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          value={option?.DOHeaderID}
                          style={{ marginRight: 8 }}
                          checked={selectedDOs.has(option?.DOHeaderID)}
                          color="primary"
                          onChange={event => {
                            handleCheckBoxChange(event)
                          }}
                        />
                        <ListItemText
                          primary={
                            <Grid container>
                              <Grid
                                item
                                xs={8}
                                component="span"
                                className="xsTitle "
                              >
                                {option?.DocNo}
                                {formatDate(option?.GRNDate) &&
                                  ` | ${formatDate(option.GRNDate)}`}
                              </Grid>
                              <Grid
                                item
                                xs={4}
                                component="span"
                                className="xsTitle right-text highlight-text"
                              >
                                {amtStr(option?.AcceptedAmt)}
                              </Grid>
                            </Grid>
                          }
                          secondary={
                            <Grid container>
                              <Grid
                                item
                                xs={8}
                                component="span"
                                className="desc"
                                style={{
                                  wordWrap: 'break-word',
                                  wordBreak: 'break-word',
                                  whiteSpace: 'pre-wrap',
                                }}
                              >
                                {option?.PONo}
                                {option?.GRNDescription && (
                                  <>
                                    <br />
                                    {option.GRNDescription}
                                  </>
                                )}
                              </Grid>
                              <Grid
                                item
                                xs={4}
                                component="span"
                                className="xsTitle right-text highlight-text"
                              ></Grid>
                            </Grid>
                          }
                        />
                      </Fragment>
                    )}
                    renderInput={(params: any) => {
                      return (
                        <div>
                          <TextField
                            {...params}
                            variant="outlined"
                            style={{ width: '100%' }}
                            label="GRN No."
                            margin="normal"
                            onKeyDown={(event: any) => {
                              if (event.key === 'Backspace') {
                                event.stopPropagation()
                                setSelectedDOs(new Set())
                              }
                            }}
                          />
                        </div>
                      )
                    }}
                  />
                )
              }}
              name="DOHeaderID"
              label="GRN No."
              margin="normal"
              autoComplete="off"
              fullWidth
              multiline={true}
              control={control}
              select
              ref={register}
            />
          )}
          <Controller
            as={TextField}
            id="standard-basic"
            name="Description"
            label="Description"
            required
            autoComplete="off"
            control={control}
            fullWidth
            margin="dense"
            helperText={errors?.Description?.message}
            error={errors?.Description ? true : false}
            ref={register}
            defaultValue={editData ? editData?.Description : ''}
            disabled={mode === 'approve-reject'}
            multiline
          />

          <VoiceTextField
            mounted={true}
            label="Remark"
            name="Remark"
            value={voiceRemark}
            setValue={setValue}
            record={record}
            setRecord={setRecord}
            control={control}
            controllerProps={{
              error: errors?.Remark ? true : false,
              helperText: errors?.Remark?.message,
              ref: register,
              autoComplete: 'off',
            }}
          />
          {/* Self-Billed e-Invoice Implementation */}
          {isEinvoice && (
            <IsEinvoiceSelfBilled
              register={register}
              control={control}
              errors={errors}
              selfBilled={selfBilled}
              defaultMsicCodeID={defaultMsicCodeID}
              isSelfBilled={isSelfBilled}
              handleToggle={handleToggle}
              msicCodeLoading={msicCodeLoading}
              getMSICCode={getMSICCode}
              msicCodeID={msicCodeID}
              setMsicCodeID={setMsicCodeID}
              selfBilledChecking={!!selfBilled}
              haveSelfBilled={
                !!selfBilled && !!watch('isSelfBilled') && !msicCodeLoading
              }
              data={null}
              dataLoading={null}
              isDocRefID={false}
              docRefKeyID={null}
              editData={editData}
            />
          )}
          <div style={{ width: '100%', marginTop: '24px' }}>
            <FileUploadInput
              placeholder={previewFiles.length === 0 ? 'Attachment' : null}
              label={previewFiles.length > 0 ? 'Attachment' : null}
              name="Attachment"
              files={files}
              onHandleUploadChange={handleUploadChange}
              multiple
              accept={
                '.png, .jpg, .jpeg, .gif, .mp4, .avi, .mkv, .mov, .flv, .3gp, application/msword, application/pdf, application/vnd.ms-excel, application/*, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              }
              imagePreview={
                <>
                  {previewFiles?.map((v, i) => (
                    <UploadPreview
                      remove
                      key={v}
                      src={v}
                      onClick={() => removeFile(i)}
                      mediaType={
                        files[i]?.type ?? DocData?.DocumentListing[i]?.mediaType
                      }
                    />
                  ))}
                </>
              }
            />
          </div>
        </CardContents>

        <ItemDetail
          titleLabel={'Invoice'}
          itemData={invoiceItemData}
          setOpenDialog={setOpenDialog}
          fetchExpenseItem={fetchExpenseItem}
          fetchCostCentre={fetchCostCentre}
          resetMenu={resetMenu}
          setSelectedTax={setSelectedTax}
          setDetailMode={setDetailMode}
          formMode={formMode}
          detailMode={detailMode}
          getItemByCompany={expenseItemListing}
          getCostCentre={getCostCentre}
          handleClick={handleClick}
          keyItemID={'InvoiceItemID'}
          isSelfBilled={isSelfBilled}
          creditorID={selectedCreditor}
        />
      </ContentWrapper>

      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          onClick={() => {
            !expenseItemListing?.find(
              x => x?.ExpenseItemID === menu?.obj?.ExpenseItemID
            ) &&
              fetchExpenseItem({
                variables: {
                  CompanyID,
                  ExpenseItemID: menu?.obj?.ExpenseItemID,
                },
              })
            setEdit(true)
            setOpenDialog(true)
            setDetailMode('edit')
          }}
        >
          <span className="">Edit</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            onDeleteInvoiceItem(menu?.index)
          }}
          disabled={readOnly() === true ? true : false}
        >
          <span className="">Delete</span>
        </MenuItem>
      </Menu>
      {openDialog && (
        <ItemDialog
          companyID={CompanyID}
          getDebtorAccount={getDebtorAccountListing}
          DebtorAccountLoading={DebtorAccountLoading}
          editData={editData}
          fetchSalesOrder={fetchSalesOrder}
          title={'Invoice Detail'}
          fromAP={true}
          openItemDialog={openDialog}
          setOpenItemDialog={setOpenDialog}
          watch={watch}
          menu={menu}
          ExpenseItemLoading={ExpenseItemLoading}
          CompanyID={CompanyID}
          fetchExpenseItem={fetchExpenseItem}
          CostCentreLoading={CostCentreLoading}
          fetchCostCentre={fetchCostCentre}
          getCostCentre={getCostCentre}
          getItemByCompany={expenseItemListing}
          isEdit={edit}
          itemData={invoiceItemData}
          selectedTax={selectedTax}
          setSelectedTax={setSelectedTax}
          detailMode={detailMode}
          setDetailMode={setDetailMode}
          resetMenu={resetMenu}
          primaryItemKey="InvoiceItemID"
          selfBillStatus={isSelfBilled}
          EInvoiceStarted={isEinvoice}
          creditorAcc={selectedCreditor}
          fetchMoreOptions={fetchExpenseItem}
          setOptions={setExpenseItemListing}
          totalLength={totalLength}
          localData={invoiceHeader}
          module={'APInvoice'}
          getSalesOrderByDebtor={getSalesOrderByDebtor}
          SalesOrderLoading={SalesOrderLoading}
          docType={'ap-invoice'}
        />
      )}

      <AddFavoriteDialog
        openFavoriteDialog={openFavoriteDialog}
        setOpenFavoriteDialog={setOpenFavoriteDialog}
        favRegister={favRegister}
        favControl={favControl}
        favNames={favNames}
        favErrors={favErrors}
        favWatch={favWatch}
        dialogTitle={'Invoice Detail'}
        handleFavSubmit={handleFavSubmit}
        onSubmitFavorite={onSubmitFavorite}
      />

      <DeleteFavoriteDialog
        openFavoriteDeleteDialog={openFavoriteDeleteDialog}
        setOpenFavoriteDeleteDialog={setOpenFavoriteDeleteDialog}
        dialogTitle={'Favorite Invoice Entry'}
        menuFav={menuFav}
        deleteMutation={deleteAPFavoriteInvoice}
        favRefetchQuery={favRefetchQuery}
        favID={menuFav?.ID}
      />

      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          history.push(`/account-payable/${CompanyID}/invoice`)
          localStorage.removeItem('invoice')
          localStorage.removeItem('invoiceItem')
        }}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />

      {footerOptions?.length > 0 ? (
        <Footer options={[...footerOptions]} />
      ) : null}

      <TooltipAmountFooter data={invoiceItemData} module={'invoice-draft'} />
    </>
  )
}
